import { isCaisseGuestClient } from './caisseGuest';

/**
 * Utilitaires pour filtrer les clients (exclure les commerçants)
 */

/**
 * Filtre les utilisateurs pour ne garder que les clients (exclut les commerçants)
 * @param {Array} users - Liste des utilisateurs
 * @param {Array} commercants - Liste des commerçants (pour récupérer les emails)
 * @returns {Array} Liste filtrée contenant uniquement les clients
 */
export const filterClientsOnly = (users, commercants = []) => {
  if (!Array.isArray(users)) return [];
  
  // Créer un Set des emails de commerçants pour une recherche rapide
  const commercantEmails = new Set(
    commercants
      .map(c => c.email?.toLowerCase())
      .filter(Boolean)
  );
  
  // Log pour debug
  console.log('[FILTER] Emails de commerçants à exclure:', Array.from(commercantEmails));
  console.log('[FILTER] Nombre de commerçants:', commercants.length);
  
  // Ajouter les IDs de commerçants pour filtrer par commercantId
  const commercantIds = new Set(
    commercants
      .map(c => c.id)
      .filter(Boolean)
  );
  
  // Créer aussi un Set des emails de notification des commerçants (emailNotificationCommandes)
  const commercantNotificationEmails = new Set(
    commercants
      .map(c => c.emailNotificationCommandes?.toLowerCase())
      .filter(Boolean)
  );
  
  console.log('[FILTER] Emails de notification commerçants:', Array.from(commercantNotificationEmails));
  
  // Créer un Map pour vérifier si un utilisateur correspond à un commerçant par nom/prénom
  // Certains gérants peuvent avoir un email différent mais le même nom
  const commercantNamesMap = new Map();
  commercants.forEach(c => {
    if (c.nom) {
      const nomLower = c.nom.toLowerCase();
      commercantNamesMap.set(nomLower, c);
    }
  });
  
  // Liste des emails connus de gérants qui ne correspondent pas exactement aux emails des commerçants
  // Yann Garé est gérant d'Il Piatto mais son email est différent
  const knownGerantEmails = new Set([
    'yann.gare@gmail.com', // Yann Garé - gérant d'Il Piatto
  ]);
  
  console.log('[FILTER] Emails connus de gérants à exclure:', Array.from(knownGerantEmails));
  
  const filtered = users.filter(user => {
    // Exclure les null/undefined
    if (!user || !user.email) {
      console.log('[FILTER] Exclu: pas d\'email ou null', user?.id);
      return false;
    }

    if (isCaisseGuestClient(user)) {
      console.log('[FILTER] Exclu: compte invité caisse (POS)', user.email);
      return false;
    }
    
    // Exclure staff / livreurs — la page Clients = role CLIENT uniquement
    const roleUpper = String(user.role || '').toUpperCase();
    if (
      roleUpper === 'COMMERCANT' ||
      roleUpper === 'ADMIN' ||
      roleUpper === 'SUPER_ADMIN' ||
      roleUpper === 'LIVREUR'
    ) {
      console.log('[FILTER] Exclu: rôle non-client', user.email, user.role);
      return false;
    }
    
    // Exclure les emails de commerçants connus (gérants de commerce)
    const emailLower = user.email.toLowerCase();
    if (commercantEmails.has(emailLower)) {
      console.log('[FILTER] Exclu: email de commerçant connu (gérant)', user.email);
      return false;
    }
    
    // Exclure aussi les emails de notification des commerçants (gérants)
    if (commercantNotificationEmails.has(emailLower)) {
      console.log('[FILTER] Exclu: email de notification commerçant (gérant)', user.email);
      return false;
    }
    
    // Exclure les emails connus de gérants
    if (knownGerantEmails.has(emailLower)) {
      console.log('[FILTER] Exclu: email connu de gérant', user.email);
      return false;
    }
    
    // Exclure les utilisateurs qui ont un commercantId (associés à un commerce en tant que gérant)
    // Un vrai client n'a pas de commercantId
    if (user.commercantId) {
      console.log('[FILTER] Exclu: a un commercantId (gérant)', user.email, 'commercantId:', user.commercantId);
      return false;
    }
    
    // Vérifier si le nom de l'utilisateur correspond à un nom de commerçant
    // (certains gérants peuvent avoir le même nom que leur commerce)
    if (user.nom) {
      const userNomLower = user.nom.toLowerCase();
      const matchingCommercant = commercantNamesMap.get(userNomLower);
      if (matchingCommercant) {
        // Vérifier aussi le prénom pour éviter les faux positifs
        // Si le prénom correspond aussi, c'est probablement le gérant
        const userPrenomLower = (user.prenom || '').toLowerCase();
        const commercantNomParts = matchingCommercant.nom.toLowerCase().split(' ');
        
        // Si le nom de famille correspond ET que l'utilisateur n'a pas de commandes, c'est probablement un gérant
        // OU si le prénom + nom correspondent au nom du commerçant
        const isLikelyGerant = !user.commandes || user.commandes.length === 0;
        
        if (isLikelyGerant) {
          console.log('[FILTER] Exclu: nom correspond à un commerçant (probable gérant)', user.email, 'nom:', user.nom, 'commerçant:', matchingCommercant.nom);
          return false;
        }
      }
    }
    
    // Garder uniquement les utilisateurs avec un email valide
    if (!emailLower.includes('@')) {
      console.log('[FILTER] Exclu: email invalide', user.email);
      return false;
    }
    
    return true;
  });
  
  console.log(`[FILTER] ${filtered.length} clients trouvés sur ${users.length} utilisateurs`);
  return filtered;
};







